import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ReactExport from "react-export-excel";

// helpers
import displayDurationFloatFormat from "../../helpers/displayDurationFloatFormat";
import displayAmount from "../../helpers/displayAmount";

const useStyles = makeStyles((theme) => ({
  exportButton: {
    verticalAlign: "bottom",
    marginLeft: "10px",
    marginBottom: "10px",
  },
}));

function ExportFYF(props) {
  const classes = useStyles();

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const main = [];
  const details = [];

  if (props.data !== null) {
    props.data.forEach((row) => {
      main.push({
        store: row.storeNumber || row.store,
        otd: displayDurationFloatFormat(row.otd),
        atd: displayDurationFloatFormat(row.atd),
        tc: displayAmount(row.tc),
      });
    });

    props.data.forEach((row) => {
      details.push({
        store: row.storeNumber || row.store,
        otd: displayDurationFloatFormat(row.otd),
        atd: displayDurationFloatFormat(row.atd),
        tc: displayAmount(row.tc),
      });

      if (row.rider?.length > 0) {
        row.rider.forEach((riderRow) => {
          details.push({
            rider: riderRow.name,
            otd: displayDurationFloatFormat(riderRow.otd),
            atd: displayDurationFloatFormat(riderRow.atd),
            tc: displayAmount(riderRow.tc),
          });
        });
      }
    });
  }

  return (
    <ExcelFile
      element={
        <Button
          variant="contained"
          className={classes.exportButton}
          disabled={props.disabled || false}
        >
          Export
        </Button>
      }
      filename={props.filename}
    >
      <ExcelSheet data={main} name="Stores">
        <ExcelColumn label="Store" value="store" />
        <ExcelColumn label="OTD" value="otd" />
        <ExcelColumn label="ATD" value="atd" />
        <ExcelColumn label="TC" value="tc" />
      </ExcelSheet>
      <ExcelSheet data={details} name="Riders">
        <ExcelColumn label="Store" value="store" />
        <ExcelColumn label="Rider" value="rider" />
        <ExcelColumn label="OTD" value="otd" />
        <ExcelColumn label="ATD" value="atd" />
        <ExcelColumn label="TC" value="tc" />
      </ExcelSheet>
    </ExcelFile>
  );
}

export default ExportFYF;
